<template>
  <div class="video-program-detail-header-component">
    <program-control :program="program"
                     :can-play="canPlayVideo"
    />
    <div class="header-info">
      <div class="program-info">
        <h2 class="program-title">
          <template v-if="program.showSeq > 0">第{{ program.showSeq }}讲：</template>
          {{ program.title }}
        </h2>
        <div class="program-summary">{{ program.summary }}</div>
        <span class="program-push-time">{{ program.pushTime }}</span>
      </div>
      <div class="program-list"
           @click="handleShowProgramListPopup"
      >
        <ym-icon class="play-list-icon"
                  name="program-desc"
        />
        播放列表
      </div>
    </div>

    <audio-info :audio="audio"
                :group-buy="groupBuy"
                :join-btn="joinBtn"
                :join-status="audio.joinStatus"
                :sell="sell"
    />

    <outline-popup :program-id="program.id"
                   :programs="programs"
                   :show.sync="showOutline"
                   :active="currentId"
                   popup-type="mp4"
                   @click="handleClickOutlineItem"
                   @switch-sort="handleSwitchSort"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import AudioInfo from '@/pages/AudioProgram/components/AudioInfo';
  import OutlinePopup from '@/pages/AudioProgram/components/OutlinePopup';
  import ProgramControl from '@/pages/VideoProgram/components/VideoProgramControl';
  import validator from '@/utils/validator';

  export default {
    name: 'VideoProgramDetailHeader',
    components: {
      AudioInfo,
      OutlinePopup,
      ProgramControl,
    },
    props: {
      program: {
        type: Object,
        required: true,
      },
      audio: {
        type: Object,
        required: true,
      },
      programs: {
        type: Array,
        required: true,
      },
      joinBtn: {
        type: Object,
        required: true,
      },
      groupBuy: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      sell: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        showOutline: false,
      };
    },
    computed: {
      ...mapGetters([
        'videoPlaylist',
      ]),
      isMember() {
        const { audio } = this;
        const { joinStatus } = audio;
        return joinStatus === 'member' || joinStatus === 'vipMember';
      },
      isDemoProgram() {
        const { program } = this;
        const { trialLength } = program;
        return trialLength === -1;
      },
      canPlayVideo() {
        const { isMember, isDemoProgram } = this;
        return isMember || isDemoProgram;
      },
      currentId() {
        return this.program.id;
      },
    },
    methods: {
      ...mapActions([
        'toggleVideoPlaylist',
      ]),
      handleDisabledJoin() {
        this.$emit('disabledJoin');
      },
      handleShowProgramListPopup() {
        this.showOutline = true;
      },
      handleClickOutlineItem(id) {
        const { currentId } = this;
        if (currentId === id) return;
        const { player } = this;
        player.pause();
        const route = { name: 'AudioProgramDetail', params: { id } };
        this.$router.push(route);
      },
      handleSwitchSort() {
        this.toggleVideoPlaylist(this.videoPlaylist.reverse());
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .header-info {
    position: relative;
    padding: @size-small @size-base;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-small;
    background: @color-white;
    color: @color-text-base;
    &:after {
      position: absolute;
      left: @size-base;
      bottom: 0;
      content: '';
      width: 690px;
      height: 1px;
      background: @background-color-base;
    }
  }

  .program-info {
    width: 530px;
  }

  .program-title {
    margin: 0;
    padding: 0;
    font-weight: @font-weight-bold;
    font-size: @font-size-base;
    line-height: 1.4;
  }

  .program-summary {
    margin-top: @size-extra-small + @size-extra-small / 2;
    margin-bottom: @size-extra-small;
    line-height: 1.4;
    font-size: @font-size-small;
  }

  .program-push-time {
    line-height: 1;
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .program-list {
    margin-top: @size-base;
    width: 88px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    color: @color-text-light;
    font-size: @font-size-extra-small;
    white-space: nowrap;
  }
  .play-list-icon {
    margin-bottom: @size-small;
    font-size: @font-size-largest;
  }
</style>
